var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProgressCell',{staticClass:"ProductProgress",attrs:{"icon":"laptop","isFlexible":true,"isLoading":_vm.isProcessing,"label":_vm.label,"theme":_vm.theme},on:{"click":_vm.pickProducts}})}
var staticRenderFns = []

export { render, staticRenderFns }